(function () {
  'use strict';

  function RoiCalculatorApp(container) {
    this.container = container;
    this.init();
  }

  RoiCalculatorApp.prototype.init = function () {
    // Find the option marked as selected or fallback to the first option
    var initialOption = this.container.querySelector('[data-roi-option].is-selected, [data-option].is-selected') 
                     || this.container.querySelector('[data-roi-option], [data-option]');

    if (initialOption) {
      // 1. Ensure 'is-selected' class is present on active option
      initialOption.classList.add('is-selected');

      // 2. Sync bottom active card summary
      this.updateCardSummary(initialOption);

      // 3. Sync top dropdown trigger UI (Title & Image)
      var dropdownWrapper = this.container.querySelector('[data-roi-custom-select]');
      if (dropdownWrapper) {
        var triggerBtn = dropdownWrapper.querySelector('[data-roi-select-trigger]');
        if (triggerBtn) {
          var triggerTitle = triggerBtn.querySelector('[data-roi-trigger-title]');
          var triggerImg = triggerBtn.querySelector('[data-roi-trigger-img]');
          
          var formattedPrice = initialOption.getAttribute('data-formatted-price') || '';
          var title = initialOption.getAttribute('data-title') || '';
          var image = initialOption.getAttribute('data-image') || '';

          if (triggerTitle) triggerTitle.textContent = title + (formattedPrice ? ' — ' + formattedPrice : '');
          if (triggerImg && image) triggerImg.src = image;
        }
      }
    }

    this.bindEvents();
    this.update();
  };

  RoiCalculatorApp.prototype.updateCardSummary = function (el) {
    if (!el) return;

    var title = el.getAttribute('data-title') || (el.dataset ? el.dataset.title : '');
    var price = parseFloat(el.getAttribute('data-price') || (el.dataset ? el.dataset.price : 0) || 0);
    var capacity = el.getAttribute('data-capacity') || (el.dataset ? el.dataset.capacity : '');
    var image = el.getAttribute('data-image') || (el.dataset ? el.dataset.image : '');
    var url = el.getAttribute('data-url') || (el.dataset ? el.dataset.url : '');

    var formattedPrice = el.getAttribute('data-formatted-price') || new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);

    var cardTitle = this.container.querySelector('[data-roi-card-title]');
    var cardPrice = this.container.querySelector('[data-roi-card-price]');
    var cardCap = this.container.querySelector('[data-roi-card-capacity]');
    var cardImg = this.container.querySelector('[data-roi-card-img]');
    var cardLink = this.container.querySelector('[data-roi-card-link]');

    if (cardTitle) cardTitle.textContent = title;
    if (cardPrice) cardPrice.textContent = formattedPrice;
    if (cardCap) cardCap.textContent = capacity;
    if (cardImg) cardImg.src = image;
    if (cardLink) cardLink.href = url;
  };

  RoiCalculatorApp.prototype.getParams = function () {
    var self = this;
    var read = function (selector, fallback) {
      var el = self.container.querySelector(selector);
      if (!el) return fallback;
      var val = parseFloat(el.value);
      return isNaN(val) ? fallback : val;
    };

    var machinePrice = parseFloat(this.container.getAttribute('data-product-price')) || 2590;
    var machineCapacity = parseFloat(this.container.getAttribute('data-product-capacity')) || 120;

    var selectedOption = this.container.querySelector('[data-roi-option].is-selected, [data-option].is-selected') 
      || this.container.querySelector('[data-roi-option], [data-option]');

    if (selectedOption) {
      var optPrice = parseFloat(selectedOption.getAttribute('data-price'));
      var optCap = parseFloat(selectedOption.getAttribute('data-capacity'));
      if (!isNaN(optPrice) && optPrice > 0) machinePrice = optPrice;
      if (!isNaN(optCap) && optCap > 0) machineCapacity = optCap;
    }

    return {
      presses: read('input[name="presses"], [data-roi-input="presses"], [data-roi-slider="presses"]', 1),
      items: read('input[name="items"], [data-roi-input="items"], [data-roi-slider="items"]', 1100),
      price: read('input[name="price"], [data-roi-input="price"], [data-roi-slider="price"]', 25),
      cogs: read('input[name="cogs"], [data-roi-input="cogs"], [data-roi-slider="cogs"]', 10),
      labor: read('input[name="labor"], [data-roi-input="labor"], [data-roi-slider="labor"]', 20),
      hoursPerDay: read('input[name="hours"], [data-roi-input="hours"], [data-roi-slider="hours"]', 8),
      machinePrice: machinePrice,
      capacityPerHour: machineCapacity
    };
  };

  RoiCalculatorApp.prototype.update = function () {
    var params = this.getParams();

    var weeklyItems = params.items || 0;
    var salePrice = params.price || 0;
    var blankCost = params.cogs || 0;
    var laborRate = params.labor || 0;
    var hoursPerDay = params.hoursPerDay || 8;
    var machineCapacity = params.capacityPerHour || 120;
    var totalMachineCost = (params.machinePrice || 0) * (params.presses || 1);

    var totalRevenue = weeklyItems * salePrice;
    var hoursToProduce = machineCapacity > 0 ? (weeklyItems / machineCapacity) : 0;
    var daysToProduce = hoursPerDay > 0 ? (hoursToProduce / hoursPerDay) : 0;

    var totalCogs = weeklyItems * blankCost;
    var totalLabor = hoursToProduce * laborRate;
    var totalCosts = totalCogs + totalLabor;

    var netProfit = totalRevenue - totalCosts;
    var profitMargin = totalRevenue > 0 ? (netProfit / totalRevenue) * 100 : 0;

    var hourlyNetProfit = hoursToProduce > 0 ? (netProfit / hoursToProduce) : 0;
    var dailyNetProfit = hourlyNetProfit * hoursPerDay;

    var timeToRoiHours = hourlyNetProfit > 0 ? (totalMachineCost / hourlyNetProfit) : 0;
    var timeToRoiDays = hoursPerDay > 0 ? (timeToRoiHours / hoursPerDay) : 0;

    var fmt = function (val) {
      return '$' + val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    var setElText = function (selector, text) {
      var els = document.querySelectorAll(selector);
      els.forEach(function (el) { el.textContent = text; });
    };

    setElText('[data-roi-metric="revenue"]', fmt(totalRevenue));
    setElText('[data-roi-metric="costs"]', fmt(totalCosts));
    setElText('[data-roi-metric="days"]', daysToProduce.toFixed(2) + ' days');
    setElText('[data-roi-metric="hours"]', hoursToProduce.toFixed(2) + ' hrs');
    setElText('[data-roi-metric="profit"]', fmt(netProfit));
    setElText('[data-roi-metric="margin"]', profitMargin.toFixed(2) + '%');

    if (netProfit <= 0) {
      setElText('[data-roi-metric="time_to_roi"], [data-roi-metric="roi"]', 'N/A (Loss-making)');
    } else {
      setElText('[data-roi-metric="time_to_roi"], [data-roi-metric="roi"]', timeToRoiDays.toFixed(2) + ' Days');
    }

    setElText('[data-roi-metric="daily_profit"], [data-roi-metric="daily"]', fmt(dailyNetProfit));
  };

  RoiCalculatorApp.prototype.bindEvents = function () {
    var self = this;

    // Custom Dropdown Event Handling
    var dropdownWrapper = this.container.querySelector('[data-roi-custom-select]');
    if (dropdownWrapper) {
      var triggerBtn = dropdownWrapper.querySelector('[data-roi-select-trigger]');
      var optionsMenu = dropdownWrapper.querySelector('[data-roi-select-options]');

      if (triggerBtn && optionsMenu) {
        // Toggle options menu
        triggerBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = !optionsMenu.hasAttribute('hidden');
          if (isOpen) {
            optionsMenu.setAttribute('hidden', '');
            dropdownWrapper.classList.remove('is-open');
          } else {
            optionsMenu.removeAttribute('hidden');
            dropdownWrapper.classList.add('is-open');
          }
        });

        // Option click listener
        var optionItems = dropdownWrapper.querySelectorAll('[data-roi-option], [data-option]');
        optionItems.forEach(function (option) {
          option.addEventListener('click', function () {
            optionItems.forEach(function (opt) { opt.classList.remove('is-selected'); });
            option.classList.add('is-selected');

            var triggerTitle = triggerBtn.querySelector('[data-roi-trigger-title]');
            var triggerImg = triggerBtn.querySelector('[data-roi-trigger-img]');
            
            var formattedPrice = option.getAttribute('data-formatted-price') || '';
            var title = option.getAttribute('data-title') || '';
            var image = option.getAttribute('data-image') || '';

            if (triggerTitle) triggerTitle.textContent = title + (formattedPrice ? ' — ' + formattedPrice : '');
            if (triggerImg && image) triggerImg.src = image;

            optionsMenu.setAttribute('hidden', '');
            dropdownWrapper.classList.remove('is-open');

            // Update active card and recalculate ROI metrics
            self.updateCardSummary(option);
            self.update();
          });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
          if (!dropdownWrapper.contains(e.target)) {
            optionsMenu.setAttribute('hidden', '');
            dropdownWrapper.classList.remove('is-open');
          }
        });
      }
    }

    // Sliders & Text Inputs Sync
    var inputs = this.container.querySelectorAll('input');
    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var key = input.getAttribute('data-roi-input') || input.getAttribute('data-roi-slider') || input.name;
        if (key) {
          var matching = self.container.querySelectorAll('[data-roi-input="' + key + '"], [data-roi-slider="' + key + '"], input[name="' + key + '"]');
          matching.forEach(function (m) {
            if (m !== input) m.value = input.value;
          });
        }
        self.update();
      });
      input.addEventListener('change', function () { self.update(); });
    });

    // Download/Print Button
    var downloadBtn = this.container.querySelector('[data-roi-download]');
    if (downloadBtn) {
      downloadBtn.removeAttribute('disabled');
      downloadBtn.setAttribute('aria-disabled', 'false');
      downloadBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.print();
      });
    }
  };

  function initCalculator() {
    var containers = document.querySelectorAll('[data-roi-calc], .roi-calc, .roi-calculator');
    containers.forEach(function (container) {
      new RoiCalculatorApp(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }
})();